import React from 'react';

import styled from 'styled-components';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import { toFriendlyDateTimeString } from 'helpers/Formatter';
import { ButtonPrimary } from '@yuhu-inc/yuhui';
import { colors } from 'helpers/ColorHelper';
import TextBox from 'components/ui/TextBox';

const StyledInternalCommentsContainer = styled.div`
  padding: 8px;
  background-color: ${(props) => (props.noBackground ? 'inherit' : 'white')};
  border-radius: 12px;
  width: 100%;
`;

const StyledInternalCommentsHeader = styled.div`
  font-size: 1.5rem;
  margin-bottom: 10px;
`;

const StyledLabel = styled.div`
  margin-bottom: 5px;
  color: ${(props) => (props.noComments ? colors.DISABLED_GRAY : colors.DARK_GRAY)};
`;

const StyledTextArea = styled(TextBox.TextArea)`
  width: 100%;
`;

const StyledPostedCommentContainer = styled.div`
  margin-top: 15px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid ${colors.LIGHT_PERIWINKLE};
  background-color: ${(props) => (props.showBackground ? 'white' : 'inherit')};
`;

const StyledPostedCommentDetailsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 7px 0px;
  align-items: center;
`;

const StyledSentOn = styled.div`
  color: ${colors.FONT_GRAY};
`;

const StyledAuthor = styled.h6`
  margin: 0px;
`;

const StyledSend = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  bottom: 35px;
  right: 8px;
`;

export const InternalComments = ({
  canAddNewNotes,
  disableSend,
  handleCommentChange,
  comments,
  values,
  showOnlyComments,
  noBackground,
}) => {
  const noComments = showOnlyComments && comments && comments.length === 0;

  return (
    <StyledInternalCommentsContainer noBackground={noBackground}>
      <StyledInternalCommentsHeader>
        {getTranslatedString('landlordPortal.internalComments.internalComments')}
      </StyledInternalCommentsHeader>

      <StyledLabel noComments={noComments}>
        {noComments
          ? getTranslatedString('landlordPortal.internalComments.noCommentsAdded')
          : getTranslatedString('landlordPortal.internalComments.comment')}
      </StyledLabel>
      {!showOnlyComments && (
        <div>
          <StyledTextArea
            value={values.internal_comments}
            rows="3"
            placeholder={getTranslatedString('landlordPortal.internalComments.addANote')}
            onChange={handleCommentChange}
          />
          {canAddNewNotes && (
            <StyledSend>
              <ButtonPrimary
                style={{
                  height: '22px',
                  lineHeight: '21px',
                  padding: '1px 15px',
                }}
                type="submit"
                contentKey="post"
                disabled={disableSend}
              />
            </StyledSend>
          )}
        </div>
      )}

      {comments &&
        comments.map((comment) => (
          <StyledPostedCommentContainer showBackground={noBackground}>
            <StyledPostedCommentDetailsContainer>
              <StyledAuthor>{comment.author}</StyledAuthor>
              <StyledSentOn>
                {getTranslatedString('landlordPortal.internalComments.sentOn', {
                  date: toFriendlyDateTimeString(comment.time, {
                    language: getCurrentLocale(),
                  }),
                })}
              </StyledSentOn>
            </StyledPostedCommentDetailsContainer>
            <div>{comment.verbiage[0]}</div>
          </StyledPostedCommentContainer>
        ))}
    </StyledInternalCommentsContainer>
  );
};
